import Swal from 'sweetalert2'

// import {
//   CustomModalCategoria,
//   CustomModalQuestion,
//   CustomModalTransacts
// } from '../component/Modal/style'
// import {ModalTransactContent} from '../component/Modal';

// const withoutCategory = () => {
//   return CustomModalCategoria.fire({
//     position: 'center',
//     // width: '25rem',
//     padding: '2rem',
//     text: 'Este producto no tiene unidades disponibles',
//     showConfirmButton: true,
//     confirmButtonText: 'Aceptar'
//   })
// }

// const emptyCar = () => {
//   return CustomModalCategoria.fire({
//     position: 'center',
//     // width: '25rem',
//     padding: '2rem',
//     text: 'Se ha vaciado el carrito con éxito',
//     showConfirmButton: true,
//     confirmButtonText: 'Aceptar'
//   })
// }

const notify = (messageTitle: string) => {
  return Swal.fire({
    position: 'top-end',
    icon: 'success',
    title: messageTitle,
    showConfirmButton: true,
    confirmButtonText: 'Aceptar',
    timer: 1500
  })
}

const error = (messageTitle: string) => {
  return Swal.fire({
    icon: 'error',
    title: 'Oops...',
    text: messageTitle
  })
}

const success = (messageTitle: string) => {
  return Swal.fire({
    icon: 'success',
    title: 'Completado',
    text: messageTitle
  })
}

const info = (messageTitle: string) => {
  return Swal.fire({
    title: 'Info',
    icon: 'info',
    text: messageTitle
  })
}

const warn = (messageTitle: string) => {
  return Swal.fire({
    title: 'Advertencia',
    icon: 'warning',
    text: messageTitle,
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Si, estoy seguro/a',
    cancelButtonText: 'No, cancelar'
  })
}

const message = (messageTitle: string) => {
  return Swal.fire({
    position: 'center',
    padding: '2rem',
    text: messageTitle,
    showConfirmButton: true,
    confirmButtonText: 'Aceptar'
  })
}

// const transactResult = (result,name,number,history, channel = null, id_cart = null, catalogo=null ) => {
//     return CustomModalTransacts.fire({
//       padding: '2rem',
//       //icon: result === 'success' ? 'success' : result === 'reject' ? 'error' : 'warning',
//       html: (<ModalTransactContent cases={result} name={name} number={number} channel={channel} id_cart={id_cart} />),
//       confirmButtonText: 'Finalizar',
//     }).then(()=>{
//       if(result === 'Rechazada'){
//         history.push(`/catalogo/avon/carrito/${id_cart}`)

//       }else if(result === 'Cancelada'){
//         history.push(`/catalogo/avon/carrito/${id_cart}`)
        
//       }else{
//         history.push(`/catalogo/${catalogo}`)
//       }
//     })
// }

// const question = (message_initial, message_result, handleSubmit, nameButtonConfirm = 'Aceptar', nameButtonCancel = 'Cancelar') => {
//   return CustomModalQuestion.fire({
//     position: 'center',
//     padding: '2rem',
//     text: message_initial,
//     showConfirmButton: true,
//     confirmButtonText: nameButtonConfirm,
//     showCancelButton: true,
//     cancelButtonText: nameButtonCancel
//   }).then(async (result) => {
//     if (result.value) {
//       if(handleSubmit !== null){
//         await handleSubmit()
//       }else{
//         message(message_result);
//       }
//     }
//   })
// }

export { notify, error, success, info, warn, message }
